import React, { useState } from 'react'
import { Button, ButtonVariant } from '../Button/Button'
import { IntegrationServiceId } from '../../common/integrations'
import { selectAccountId } from '../../store/auth/authSlice'
import { useAppSelector } from '../../store/hooks'
import { ScopedBlock } from '../ScopedBlock/ScopedBlock'
import { MissingScopeAction } from '../ScopedBlock/models'
import { getIntegrationEnableUrl, getIntegrationRedirectUri } from '../../views/Integration/utils'

export type EmailConnectButtonProps = {
  hasOtherMailIntegration: boolean
  serviceId: IntegrationServiceId
  redirectState: string
  variant?: ButtonVariant
} & Pick<React.ComponentPropsWithoutRef<'button'>, 'className' | 'children'>

export const EmailConnectButton: React.FC<EmailConnectButtonProps> = ({
  className,
  serviceId,
  redirectState,
  hasOtherMailIntegration,
  children,
  variant = 'primary',
}) => {
  const accountId = useAppSelector(selectAccountId)
  const [loading, setLoading] = useState<boolean>(false)

  const authorizeEmail = () => {
    setLoading(true)
    const redirectUri = getIntegrationRedirectUri(serviceId)
    window.location.href = getIntegrationEnableUrl(accountId, serviceId, redirectUri, redirectState)
  }

  return (
    <ScopedBlock
      scope={{
        scope: 'integration:connect',
        superScope: ['integration:admin'],
      }}
      missingScopeAction={MissingScopeAction.DISABLE}
    >
      <Button className={className} variant={variant} onClick={authorizeEmail} disabled={hasOtherMailIntegration || loading}>
        {children}
      </Button>
    </ScopedBlock>
  )
}
